export default {"src":"/_next/static/media/woman_raising_hand_color_medium.7edf404c.svg","height":32,"width":32};